
export default function GroutHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1A1A1A] to-[#2d2d2d] text-white py-12 md:py-20 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="w-full md:w-1/2">
            <span className="inline-block text-white/60 uppercase tracking-widest text-xs font-semibold mb-4">
              Contractor Grade
            </span>
            <h1 className="font-['Montserrat'] font-bold text-[2rem] md:text-4xl lg:text-5xl mb-6 leading-tight">
              Grout
            </h1>
            <p className="text-base md:text-lg text-gray-300 mb-6">
              Professional-grade Contractor Grade grout for lasting tile installations. Stain-resistant, durable, and available in a wide colour range — built for the demands of every tiling job.
            </p>
          </div>
          <div className="w-full md:w-1/2">
            <div className="w-full h-[400px] rounded-lg overflow-hidden bg-[#2d2d2d] flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/48a33e494ab59672b788372208818b2e.png"
                alt="Best Contractor Grade Grout"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
